import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_CREATE_USER, ASYNC_EDIT_USER } from 'store';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import { api } from 'services';
import { useTranslation } from 'react-i18next';
import FormControl from 'helpers/FormControl';
import MasterPage from 'components/MasterPage';
import Input from 'helpers/Input';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import { DashboardOutlined } from '@material-ui/icons';

const UsersForm = ({
  createOrEditUser,
  match: {
    params: { id }
  },
  area
}) => {
  const [languages, setLanguages] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [alias, setAlias] = useState('');
  const [language, setLanguage] = useState('');
  const [profile, setProfile] = useState('');
  const [profileType, setProfileType] = useState('');
  const [errors, setErrors] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const VendorsArr = [];
  const VendorsSelectedArr = [];
  var compArr = [];

  useEffect(() => {
    api.get('languages').then(({ data }) => setLanguages(data));

    api
      .get(`areas/${area.id}/profiles`)
      .then(({ data }) => setProfiles(data));

    api
      .get('companies/all')
      .then(({ data }) => {
        setCompanies(data);
      });

    if (id) {
      api.get(`users/${id}`).then(({ data }) => {
        setFirstname(data.firstname);
        setLastname(data.lastname);
        setEmail(data.email);
        setPhone(data.phone ? data.phone : '');
        setAlias(data.alias ? data.alias : '');
        setLanguage(data.language_id);
        setProfile(data.profiles[0].id);
        setSelectedCompanies(data.companies);
      });
    }
  }, [id, area.id]);

  const { t } = useTranslation();

  const getVendors = (companies, array) => {
    companies.map((company) => {
      return array.push({
        id: company.id,
        label: company.alias,
      });
    });

    array.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    array.map((label) => {
      return companies[label.index];
    });
  };

  const handleChangeCompanies = e => {
    compArr = [];
    e.map((c, k) => {
      if (!compArr.includes(c.id))
        compArr.push(c.id);
    })
  }

  getVendors(companies, VendorsArr);
  getVendors(selectedCompanies, VendorsSelectedArr);

  VendorsSelectedArr.map((c, k) => {
    if (!compArr.includes(c.id))
      compArr.push(c.id);
  });

  const handleError = errors => setErrors(errors);

  const handleSubmit = e => {
    e.preventDefault();

    createOrEditUser(
      {
        id,
        firstname,
        lastname,
        email,
        phone,
        alias,
        language,
        profile,
        compArr
      },
      handleError
    );
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Card.Body className="shadow bg-white rounded">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            {id ? (
              <h4 className="title-dashboard mt-2">
                {t('title:editing')}{' '}
                {firstname} {lastname}
              </h4>
            ) : firstname ? (
              <h4 className="title-dashboard mt-2">
                {t('title:creating')}{' '}
                {firstname} {lastname}
              </h4>
            ) : (
                  <h4 className="title-dashboard mt-2">{t('title:create user')}</h4>
                )}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:firstname')}</Form.Label>
                  <FormControl
                    value={firstname}
                    onChange={e => setFirstname(e.target.value)}
                    validation={errors.firstname}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:lastname')}</Form.Label>
                  <FormControl
                    value={lastname}
                    onChange={e => setLastname(e.target.value)}
                    validation={errors.lastname}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:email')}</Form.Label>
                  <FormControl
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    validation={errors.email}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:phone')}</Form.Label>
                  <Input.Phone
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    validation={errors.phone}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:alias')}</Form.Label>
                  <FormControl
                    value={alias}
                    onChange={e => setAlias(e.target.value)}
                    validation={errors.alias}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:language')}</Form.Label>
                  <FormControl
                    as="select"
                    value={language}
                    onChange={e => setLanguage(e.target.value)}
                    validation={errors.language}
                    required
                  >
                    <option disabled={true} value="">
                      {t('label:select')}
                    </option>
                    {languages.map((lang, k) => (
                      <option key={k} value={lang.id}>
                        {lang.name}
                      </option>
                    ))}
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>{t('label:profile')}</Form.Label>
                  <FormControl
                    as="select"
                    value={profile}
                    onChange={e => setProfile(e.target.value)}
                    validation={errors.profile}
                    required
                  >
                    <option disabled={true} value="">
                      {t('label:select')}
                    </option>
                    {profiles.map((profile, k) => (
                      <option key={k} value={profile.id}>
                        {profile.name}
                      </option>
                    ))}
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>

        {profile == 3 ? (
          <>
            <Row className="mt-2 mb-4">
              <Col>
                <h4 className="mb-2">{t('title:companies')}</h4>
                <MultiSelect
                  items={VendorsArr}
                  selectedItems={VendorsSelectedArr}
                  onChange={handleChangeCompanies}
                />
              </Col>
            </Row>
          </>) : null
        }
        <Row>
          <Button variant="dark" type="submit" className="ml-3">
            {t('label:save')}
          </Button>
        </Row>
      </Card.Body >
    </Form >
  );
};

const mapStateToProps = state => ({
  area: state.area
});

const mapDispatchToProps = dispatch => ({
  createOrEditUser: (payload, handleError) => {
    if (payload.id) dispatch({ type: ASYNC_EDIT_USER, payload, handleError });
    else dispatch({ type: ASYNC_CREATE_USER, payload, handleError });
  }
});

const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(UsersForm);

export default MasterPage(reduxConnect);
